export default "__VITE_ASSET__Dr05vnZq__"